document.smarties = {};
document.smarties.setCookie = function (name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

document.smarties.getCookie = function (name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
        if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
    }
    return null;
}

window.addEventListener('load', function () {
    const newsletterCookie = document.smarties.getCookie("hide_newsletter");
    const popup = document.getElementById("newsletter-popup");
    const closeBtn = document.querySelector(".popup-close");
    if (popup && closeBtn) {
        if (!newsletterCookie) {
    // popup.classList.add("open"); // disabilitato - non si apre automaticamente
         }
        
        closeBtn.addEventListener("click", function () {
            popup.classList.remove("open");
            document.smarties.setCookie("hide_newsletter", true, 30);
        });

        const triggerInput = document.getElementById("trigger-input-email");
        if (triggerInput) {
            triggerInput.addEventListener("click", function () {
                popup.classList.add("open");
            });
        }

        const submitBtn = popup.querySelector('.newsletter-form-submit');
        if (submitBtn) {
            submitBtn.addEventListener("click", function () {
                document.smarties.setCookie("hide_newsletter", true, 30);
            });
        }
    }

    setTimeout(() => {
        const invoiceRequired = document.querySelector('.cart__vat-checkbox input');
        if (invoiceRequired && invoiceRequired.checked) {
            // Toggle the class on the container
            const vatContainer = document.querySelector('.cart__vat-container');
            if (vatContainer) {
                vatContainer.classList.toggle('show');
            }
    
            // Set 'required' attribute for VAT fields
            const vatFields = document.querySelectorAll('.cart__vat-fields input');
            vatFields.forEach(field => {
                field.setAttribute('required', 'required');
            });
        }
    }, 100);
    

    document.addEventListener('click', function (event) {
        if (event.target.matches('.cart__vat-checkbox input')) {
            // Toggle the class on the container
            const vatContainer = document.querySelector('.cart__vat-container');
            if (vatContainer) {
                vatContainer.classList.toggle('show');
            }
    
            // Handle the VAT field
            const vatField = document.querySelector('.cart__vat-field.vat-field input');
            if (vatField) {
                if (vatField.hasAttribute('required')) {
                    vatField.removeAttribute('required');
                } else {
                    vatField.setAttribute('required', 'required');
                }
                vatField.value = ''; // Clear the value
            }
        }
    });
    
    // Remove 'disabled' attribute from the checkbox
    const vatCheckbox = document.querySelector('.cart__vat-checkbox input');
    if (vatCheckbox) {
        vatCheckbox.removeAttribute('disabled');
    }    
});
